/**
 * Returns the element height including margins
 * @param {HTMLElement} element - element
 * @returns {number}
 */
function outerHeight(element) {
  const height = element.offsetHeight
  const style = window.getComputedStyle(element)

  return ['top', 'bottom']
    .map((side) => parseInt(style[`margin-${side}`]), 10)
    .reduce((total, side) => total + side, height)
}

/**
 * Sets the minimum height for all teaser carousels
 */
function setTeaserCarouselsHeight() {
  const teaserCarousels = document.querySelectorAll('.js-teaser-carousel')
  teaserCarousels.forEach((teaserCarousel) => {
    const featuredItem = teaserCarousel.querySelector(
      '.js-carousel-item.teasers__carousel-item--featured'
    )
    if (!featuredItem) {
      return
    }

    const currentHeight = outerHeight(featuredItem) + 'px'
    teaserCarousel.style.setProperty('--hh-min-height', currentHeight)
    resetTeaserCarouselItemsHeight(teaserCarousel)
    setTeaserCarouselItemsHeight(teaserCarousel)
  })
}

function resetTeaserCarouselItemsHeight(teaserCarousel) {
  const teaserCarouselItems =
    teaserCarousel.querySelectorAll('.js-carousel-item')

  teaserCarouselItems.forEach((teaserCarouselItem) => {
    teaserCarouselItem.style.removeProperty('--hh-item-height')
  })
}

function setTeaserCarouselItemsHeight(teaserCarousel) {
  setTimeout(() => {
    const featuredCarouselItem = teaserCarousel.querySelector(
      '.js-carousel-item.teasers__carousel-item--featured'
    )

    if (featuredCarouselItem) {
      const featuredCarouselItemClone = featuredCarouselItem.cloneNode(true)
      featuredCarouselItemClone.classList.add('opacity-0')
      featuredCarouselItemClone.classList.remove(
        'teasers__carousel-item--featured'
      )
      teaserCarousel.appendChild(featuredCarouselItemClone)
      setTimeout(() => {
        const minHeight = featuredCarouselItemClone.offsetHeight
        teaserCarousel.removeChild(featuredCarouselItemClone)
        updateTeaserCarouselItemsHeight(minHeight, teaserCarousel)
      }, 100)
      return
    }

    updateTeaserCarouselItemsHeight(0, teaserCarousel)
  }, 500)
}

/**
 * Calculate and set the minimum height the carousel items must have in a teaser carousel
 * @param {Number} initialMinHeight - Initial value for min height
 * @param {HTMLElement[]} teaserCarousel - Carousel
 */
function updateTeaserCarouselItemsHeight(initialMinHeight = 0, teaserCarousel) {
  let minHeight = initialMinHeight
  const teaserCarouselItems = teaserCarousel.querySelectorAll(
    '.js-carousel-item:not(.teasers__carousel-item--featured)'
  )

  teaserCarouselItems.forEach((teaserCarouselItem) => {
    minHeight =
      minHeight > teaserCarouselItem.offsetHeight
        ? minHeight
        : teaserCarouselItem.offsetHeight
  })

  const allItems = teaserCarousel.querySelectorAll('.js-carousel-item')
  let minHeightAllItems = minHeight
  allItems.forEach((teaserCarouselItem) => {
    teaserCarouselItem.style.setProperty('--hh-item-height', minHeight + 'px')
    minHeightAllItems =
      minHeightAllItems > teaserCarouselItem.offsetHeight
        ? minHeightAllItems
        : teaserCarouselItem.offsetHeight
  })

  teaserCarousel.style.setProperty('--hh-min-height', minHeightAllItems + 'px')
}

/**
 * Set teaser carousel items mouseover event actions
 * @param {HTMLElement} teaserItem - Teaser carousel item to process
 * @returns
 */
function setTeaserMouseEnter(teaserItem) {
  const carousel = teaserItem.querySelector('.js-teaser-carousel')
  if (!carousel) {
    return
  }
  if (carousel.classList.contains('teasers__carousel--no-focused')) {
    return
  }

  const items = teaserItem.querySelectorAll('.js-carousel-item')
  if (!items?.length) {
    return
  }

  const className = 'teasers__carousel-item--featured'
  const ctaSelector = '.js-teaser-carousel-item-cta'
  const hasPadding = teaserItem.querySelector(
    '.js-teasers-carousel-with-padding'
  )

  const observer = new MutationObserver((mutationList, observer) => {
    mutationList.forEach(function (mutation) {
      const { type, attributeName, target } = mutation

      if (
        type === 'attributes' &&
        ['class', 'style'].indexOf(attributeName) > -1
      ) {
        const hasFeaturedClass = target.classList.contains(className)
        const itemCta = target.querySelector(ctaSelector)

        if (!itemCta || !hasPadding) {
          return
        }
        if (hasFeaturedClass) {
          itemCta.setAttribute('inverse', '')
        } else {
          itemCta.removeAttribute('inverse', '')
        }
      }
    })
  })

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (item.classList.contains(className)) {
        return
      }

      items.forEach((targetItem) => {
        targetItem.classList.remove(className)
      })

      item.classList.add(className)
    })

    observer.observe(item, {
      attributes: true,
    })
  })
}

/**
 * Extracts the video id from a Youtube URL
 * @param {string} url - The video URL
 * @returns {string | null} Video id if any
 */
function getVideoIdFromYTUrl(url) {
  try {
    const parsedUrl = new URL(url)
    if (
      parsedUrl.hostname.includes('youtube.com') &&
      parsedUrl.searchParams.has('v')
    ) {
      return parsedUrl.searchParams.get('v')
    } else if (parsedUrl.hostname.includes('youtu.be')) {
      const path = parsedUrl.pathname.replace('/', '')
      return path
    }

    return null
  } catch (error) {
    return null
  }
}

/**
 * Get the YT video poster image for teaser elements who use YT videos and don't have a poster image set in the shop admin
 */
function loadTeasersYTImage() {
  const teaserCarousels = document.querySelectorAll('.js-teaser-carousel')
  teaserCarousels.forEach((teaserCarousel) => {
    const teaserYTImages = teaserCarousel.querySelectorAll(
      '.js-video-teaser-image'
    )
    teaserYTImages.forEach((teaserYTImage) => {
      const url = teaserYTImage.dataset?.url
      if (!url) {
        return
      }

      const videoId = getVideoIdFromYTUrl(url)
      if (!videoId) {
        return
      }

      teaserYTImage.setAttribute(
        'src',
        `//img.youtube.com/vi/${videoId}/hqdefault.jpg`
      )
    })
  })
}

/**
 * Removes all 'featured' classes from a teaser carousel block
 * @param {HTMLElement} teaserCarousel - Teaser carousel element
 */
function resetTeaserCarouselClasses(teaserCarousel) {
  const featuredClass = 'teasers__carousel-item--featured'
  const carouselItems = teaserCarousel.querySelectorAll('.js-carousel-item')
  carouselItems.forEach((carouselItem) => {
    carouselItem.classList.remove(featuredClass)
  })

  if (carouselItems.length <= 3) {
    if (window.outerWidth > 600) {
      carouselItems[carouselItems.length == 3 ? 1 : 0].classList.add(
        'teasers__carousel-item--featured'
      )
    } else {
      carouselItems[0].classList.add(
        'teasers__carousel-item--featured'
      )
    }
  } else if (teaserCarousel.querySelector('.js-teasers-carousel-focused')) {
    const featuredIndex = carouselItems.length > 2 ? 1 : 0

    if (window.outerWidth > 600) {
      carouselItems[featuredIndex].classList.add(featuredClass)
    } else {
      carouselItems[0].classList.add(featuredClass)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const teaserItems = document.querySelectorAll('.js-teaser')
  teaserItems.forEach((teaserItem) => {
    setTeaserMouseEnter(teaserItem)
    resetTeaserCarouselClasses(teaserItem)
  })

  loadTeasersYTImage()
  setTimeout(() => {
    setTeaserCarouselsHeight()
  }, 1000)
})

window.addEventListener('resize', () => {
  const teaserItems = document.querySelectorAll('.js-teaser')
  teaserItems.forEach((teaserItem) => {
    if (window.outerWidth > 1023) {
      resetTeaserCarouselClasses(teaserItem)
    }
  })
})
